// src/hooks/useContagemTempo.js
import { useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

export const useContagemTempo = () => {
  // Função para obter o username
  const getUsername = () => {
    const token = localStorage.getItem('access');
    if (!token) return null;

    try {
      const decoded = jwtDecode(token);
      let username = decoded.first_name || decoded.username || decoded.sub || 'usuário';

      // Ajustes manuais de nomes
      if (username === 'Amandacarissimi') username = 'Amanda Carissimi';
      else if (username === 'Matheusscheidt') username = 'Matheus Scheidt';
      else if (username === 'Maria') username = 'Maria Eduarda';
      else if (username === 'Juliana') username = 'Juliana Lino';
      else if (username === 'Leticia') username = 'Leticia Mohr';
      else if (username === 'Lucas') username = 'Lucas Petró de Oliveira';
      else if (username === 'Luisa') username = 'Luísa Brasil';
      else if (username === 'LucasRosales') username = 'Lucas Rosales';

      return username;
    } catch (e) {
      return null;
    }
  };

  // Função para parar todas as contagens ativas
  const pararTodasContagens = async () => {
    const username = getUsername();
    if (!username) return;

    const accessToken = localStorage.getItem('access');
    if (!accessToken) return;

    try {
      // Buscar contagens ativas
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/contagens-ativas/?usuario=${username}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      const contagensAtivas = response.data.contagens || [];

      // Parar cada contagem ativa
      for (const contagem of contagensAtivas) {
        try {
          await axios.post(
            `${process.env.REACT_APP_API_BASE}/api/parar-contagem/`,
            {
              numero_dominio: contagem.numero_dominio,
              usuario: username
            },
            { headers: { Authorization: `Bearer ${accessToken}` } }
          );
          
          console.log(`Contagem parada para: ${contagem.empresa}`);
        } catch (error) {
          console.error(`Erro ao parar contagem para ${contagem.empresa}:`, error);
        }
      }

      if (contagensAtivas.length > 0) {
        console.log(`${contagensAtivas.length} contagem(ns) parada(s) automaticamente ao sair do sistema.`);
      }
    } catch (error) {
      console.error('Erro ao parar contagens ativas:', error);
    }
  };

  useEffect(() => {
    // Função para lidar com o evento beforeunload (fechar aba/navegador)
    const handleBeforeUnload = (event) => {
      // Executar de forma síncrona
      pararTodasContagens();
    };

    // Função para lidar com visibilitychange (minimizar/trocar aba)
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        pararTodasContagens();
      }
    };

    // Adicionar event listeners
    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Cleanup
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return { pararTodasContagens };
};